<template>
  <div class="pages agree_container">
    <hsj-service/>
  </div>
</template>

<script>
import hsjService from './hsj/Service.vue';
import { testApp } from '@/utils';
export default {
  name: "service",
  components: {hsjService},
  computed: {
    isHsjPro() {
      return this.testApp('hsjpro');
    }
  },
  watch: {
    isHsjPro: function (newV, oldVal) {
      if (newV && !oldVal) {
        this.$router.replace({ name: "HsjProService" });
      }
    }
  },
  created() {
    if (this.isHsjPro) {
      this.$router.replace({ name: "HsjProService" });
    }
  },
  methods: {
    testApp,
  },
};
</script>
